import { render } from "./utleyPutting.vue?vue&type=template&id=0a3739b8"
import script from "./utleyPutting.vue?vue&type=script&lang=js"
export * from "./utleyPutting.vue?vue&type=script&lang=js"

import "./utleyPutting.vue?vue&type=style&index=0&id=0a3739b8&lang=scss"
/* custom blocks */
import block0 from "@/assets/images/hardy1/hardyFinish1.png?vue&type=custom&index=0&blockType=img&issuerPath=%2Fopt%2Frender%2Fproject%2Fsrc%2Fsrc%2Fcomponents%2FUtleyPutting%2FutleyPutting.vue&alt=Hardy%20Posture"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__